import { render, staticRenderFns } from "./WhatsappSessionMobile.vue?vue&type=template&id=2ca217e9&"
import script from "./WhatsappSessionMobile.vue?vue&type=script&lang=js&"
export * from "./WhatsappSessionMobile.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappSessionMobile.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports